import { memo } from "react";

function ProductGas() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.244 17.8658C23.8886 12.0359 13.8377 0 13.8377 0C11.5643 10.3707 3.72426 11.5524 3.73335 18.3793C3.73902 22.9859 5.79441 25.6608 8.35852 27.0814C7.54659 24.3222 7.87592 21.1199 10.314 18.8051C14.8154 14.5308 15.3105 11.6562 15.3105 11.6562C19.9675 20.0583 18.8251 25.3377 17.0706 28C21.3427 26.801 24.57 23.2029 24.244 17.8658Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(ProductGas);
